<script lang="typescript">
  import type { User } from '../../common/types';
  import AddSupervisor from './AddSupervisor.svelte';
  import ListSupervisors from './ListSupervisors.svelte';
  export let users:Array<User>;
</script>

<div>
  <h1>Nykyiset ohjaajat</h1>
  <ListSupervisors {users} />

  <h1>Ohjaajien hallinta</h1>
  <AddSupervisor {users} />
</div>

<style>
</style>

